/** svc-reporting LE Data HTTP API (relative to API host or dev proxy). */

export const REPORTING_LE_DATA_ASK_PATH = '/api/reporting/le-data/ask';

export const REPORTING_LE_DATA_SESSIONS_PATH = '/api/reporting/le-data/sessions';

export const REPORTING_LE_DATA_SHARED_PATH = '/api/reporting/le-data/shared';

export const REPORTING_LE_DATA_EXPORT_PATH = '/api/reporting/le-data/export';

export const REPORTING_LE_DATA_GALLERY_BACKFILL_PATH = '/api/reporting/le-data/gallery/replay-page';

export function reportingLeDataSessionPath(sessionId: string): string {
  return `${REPORTING_LE_DATA_SESSIONS_PATH}/${encodeURIComponent(sessionId)}`;
}

export function reportingLeDataSessionVisibilityPath(sessionId: string): string {
  return `${reportingLeDataSessionPath(sessionId)}/visibility`;
}

export function reportingLeDataSessionAbortPath(sessionId: string): string {
  return `${reportingLeDataSessionPath(sessionId)}/abort`;
}

export function reportingLeDataSessionFeedbackPath(sessionId: string): string {
  return `${reportingLeDataSessionPath(sessionId)}/feedback`;
}

export function reportingLeDataSessionSteerPath(sessionId: string): string {
  return `${reportingLeDataSessionPath(sessionId)}/steer`;
}

export function reportingLeDataSharedSessionPath(sessionId: string): string {
  return `${REPORTING_LE_DATA_SHARED_PATH}/${encodeURIComponent(sessionId)}`;
}

export function reportingLeDataSessionPinPath(sessionId: string): string {
  return `${REPORTING_LE_DATA_SESSIONS_PATH}/${sessionId}/pin`;
}

export function reportingLeDataSessionCompactPath(sessionId: string): string {
  return `${REPORTING_LE_DATA_SESSIONS_PATH}/${sessionId}/compact`;
}
